import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const transactionProcessor = {
  namespaced: true,

  state: () => ({
    selectedMerchant: null,
    editProcessorClicked: false,
    debitProcessors: [],
    paymentProcessors: [],
    defaultProcessors: null,
    approvedDefaultProcessors: null,
    // ---------------------------
    merchantProcessors: [],
    approvedMerchantProcessors: []
  }),

  getters: {
    _selectedMerchant: state => state.selectedMerchant,
    _editProcessorClicked: state => state.editProcessorClicked,
    _debitProcessors: state => state.debitProcessors,
    _paymentProcessors: state => state.paymentProcessors,
    _defaultProcessors: state => state.defaultProcessors,
    _approvedDefaultProcessors: state => state.approvedDefaultProcessors,
    // ------------------------------------------------------------------
    _merchantProcessors: state => state.merchantProcessors,
    _approvedMerchantProcessors: state => state.approvedMerchantProcessors
  },

  mutations: {
    SELECTED_MERCHANT (state, data) {
      state.selectedMerchant = data
    },
    EDIT_PROCESSOR_CLICKED (state, data) {
      state.editProcessorClicked = data
    },
    DEBIT_PROCESSORS (state, data) {
      state.debitProcessors = data
    },
    PAYMENT_PROCESSORS (state, data) {
      state.paymentProcessors = data
    },
    DEFAULT_PROCESSORS (state, data) {
      state.defaultProcessors = data
    },
    APPROVED_DEFAULT_PROCESSORS (state, data) {
      state.approvedDefaultProcessors = data
    },
    // ---------------------------------------------
    MERCHANT_PROCESSORS (state, data) {
      state.merchantProcessors = data
    },
    APPROVED_MERCHANT_PROCESSORS (state, data) {
      state.approvedMerchantProcessors = data
    }
  },

  actions: {
    // ========== APP PROCESSOR ====================
    CreateDefaultProcessor ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/Processor/CreateDefaultProcessor', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateDefaultProcessor ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/Processor/UpdateDefaultProcessor', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ApproveDefaultProcessor ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get('/Processor/ApproveDefaultProcessor', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveDefaultProcessor ({ rootState, dispatch }, { headers, comment }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/Processor/DisapproveDefaultProcessor?DisapprovedComment=${comment}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetDebitProcessors ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        api.get('/Processor/GetDebitProcessors', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetPaymentProcessors ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        api.get('/Processor/GetPaymentProcessors', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetDefaultProcessors ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        api.get('/Processor/GetDefaultProcessors', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetApprovedDefaultProcessors ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        api.get('/Processor/GetApprovedDefaultProcessors', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    // ========== MERCHANT PROCESSOR ====================
    CreateMerchantProcessor ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/Processor/CreateMerchantProcessor', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateMerchantProcessor ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/Processor/UpdateMerchantProcessor', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ApproveMerchantProcessor ({ rootState, dispatch }, { headers, merchantId }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/Processor/ApproveMerchantProcessor?MerchantId=${merchantId}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchantProcessor ({ rootState, dispatch }, { headers, merchantId, comment }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/Processor/DisapproveMerchantProcessor?MerchantId=${merchantId}&DisapprovedComment=${comment}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetMerchantProcessors ({ rootState, dispatch }, { merchantId, headers }) {
      return new Promise((resolve, reject) => {
        api.get(`/Processor/GetMerchantProcessors?MerchantId=${merchantId}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetApprovedMerchantProcessors ({ rootState, dispatch }, { merchantId, headers }) {
      return new Promise((resolve, reject) => {
        api.get(`/Processor/GetApprovedMerchantProcessors?MerchantId=${merchantId}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default transactionProcessor
